import Polyglot from "node-polyglot";

export let polyglot;

let messages = {
    en: {
        cart: {
            saving: "Saving...",
            lineError: "Error: Line quantity not updated, try again. "
        },
        listings: {
            loadingRelated: "Loading related products",
            itemsSelected: " items selected",
            itemSelected: "1 item selected"
        },
        products: {
            stock: "Stock product",
            onRequest: "On request"
        },
        collapse: {
            show: "Show more",
            hide: "Show less"
        }
    },
    du: {
        cart: {
            saving: "Saving...",
            lineError: "Error: Line quantity not updated, try again. "
        },
        listings: {
            loadingRelated: "Loading related products",
            itemsSelected: " items selected",
            itemSelected: "1 item selected"
        },
        products: {
            stock: "Stock product",
            onRequest: "On request"
        },
        collapse: {
            show: "Show more",
            hide: "Show less"
        }
    },
    fr: {
        cart: {
            saving: "Saving...",
            lineError: "Error: Line quantity not updated, try again. "
        },
        listings: {
            loadingRelated: "Loading related products",
            itemsSelected: " items selected",
            itemSelected: "1 item selected"
        },
        products: {
            stock: "Stock product",
            onRequest: "On request"
        },
        collapse: {
            show: "Show more",
            hide: "Show less"
        }
    },
    es: {
        cart: {
            saving: "Grabando...",
            lineError: "Error: Cantidad no actualizada, intentalo de nuevo. "
        },
        listings: {
            loadingRelated: "Cargando productos relacionados",
            itemsSelected: " artículos seleccionados",
            itemSelected: "1 artículo seleccionado"
        },
        products: {
            stock: "En stock",
            onRequest: "Bajo pedido"
        },
        collapse: {
            show: "Mostrar más",
            hide: "Mostrar menos"
        }
    }
};

export function initPolyglot() {
    const locale = $('html').attr('lang');
    polyglot = new Polyglot({
        locale,
        phrases: messages[locale],
    });
}

